/** This project's PostHog region. Shared so the browser client and the server-side
 * flag read (terms/server.ts) can never default to different clusters. */
export const DEFAULT_POSTHOG_HOST = "https://eu.posthog.com";
